import React from "react";
// import people from '../../assets/people.png';
import { email, facebk, phone, insta } from "./imports";
import ai from "../../assets/perspic2.png";
import "./header.css";

const Header = () => {
  return (
    <div className="pt__header section__padding" id="home">
      <div className="pt__header-content">
        <h1 className="gradient__text">
          Build Something amazing with Persbe Tech
        </h1>
        <p>
          Our view of the world is that of prosperity, abundance and
          problem-solving. With the appropriate technology, we do just that.
        </p>

        <h2 className="pt__connect__text">Connect with us via:</h2>

        <div className="pt__header-content__img">
          {/* <input type="email" placeholder="Your Email Address" />
          <button type="button">Get Started</button> */}
          <a href="tel:+233538574403" target="_blank" rel="noopener noreferrer">
            {" "}
            <img title="Phone" src={phone} alt="phone" />{" "}
          </a>
          <a
            href="mailto:persbetech@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            <img title="Email" src={email} alt="email" />{" "}
          </a>
          <a
            href="https://web.facebook.com/PersbeTech"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            <img title="Facebook" src={facebk} alt="facebook" />{" "}
          </a>
          <a
            href="https://www.instagram.com/persbe_tech_academy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            <img title="Instagram" src={insta} alt="instagram" />{" "}
          </a>
        </div>

        <div className="pt__header-content__people">
          {/* <p>1,600 people requested access a visit in last 24 hours</p> */}
        </div>
      </div>

      <div className="pt__header-image">
        <img src={ai} alt="ai" />
      </div>
    </div>
  );
};

export default Header;
